import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import {
  CwButton,
  CwIcon,
  CwNavigationDrawer,
  CwNavigationDrawerItem,
  CwNavigationDrawerSection
} from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';

import { ROUTES } from '../../../definitions/constants/routes.constants';
import { UserConfigsStoreFacade } from '../../../stores/global-store/user-configs/user-configs-store.facade';

@Component({
  selector: 'app-repevo-navigation',
  imports: [
    CwNavigationDrawer,
    TranslocoDirective,
    CwButton,
    CwIcon,
    CwNavigationDrawerSection,
    CwNavigationDrawerItem,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './repevo-navigation.component.html',
  styleUrl: './repevo-navigation.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RepevoNavigationComponent {
  protected readonly userConfigsFacade = inject(UserConfigsStoreFacade);

  protected readonly ROUTES = ROUTES;

  protected readonly createOrderRoute = [ '/', ROUTES.REP_EVOLUTION, ROUTES.CREATE_ORDER ];
  protected readonly ordersRoute = [ '/', ROUTES.REP_EVOLUTION, ROUTES.OVERVIEW ];
  protected readonly helpRoute = [ '/', ROUTES.REP_EVOLUTION, ROUTES.HELP ];
  protected readonly settingsRoute = [ '/', ROUTES.REP_EVOLUTION, ROUTES.SETTINGS ];
}
